/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Pricing_Save_PercentInputs */

const en_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save ${i?.percent}%`)
};

const de_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% sparen`)
};

const fr_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Économise ${i?.percent}%`)
};

const es_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ahorra ${i?.percent}%`)
};

const it_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Risparmia ${i?.percent}%`)
};

const nl_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bespaar ${i?.percent}%`)
};

const pl_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oszczędź ${i?.percent}%`)
};

const fi_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Säästä ${i?.percent}%`)
};

const da_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spar ${i?.percent}%`)
};

const sv_pricing_save_percent = /** @type {(inputs: Pricing_Save_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spara ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Save {percent}%" |
*
* @param {Pricing_Save_PercentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_save_percent = /** @type {((inputs: Pricing_Save_PercentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Save_PercentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_save_percent(inputs)
	if (locale === "fr") return fr_pricing_save_percent(inputs)
	if (locale === "es") return es_pricing_save_percent(inputs)
	if (locale === "it") return it_pricing_save_percent(inputs)
	if (locale === "nl") return nl_pricing_save_percent(inputs)
	if (locale === "pl") return pl_pricing_save_percent(inputs)
	if (locale === "fi") return fi_pricing_save_percent(inputs)
	if (locale === "da") return da_pricing_save_percent(inputs)
	if (locale === "sv") return sv_pricing_save_percent(inputs)
	return en_pricing_save_percent(inputs)
});